import { Icon } from '@/shared/types/icon';

export const ElevenLabsIcon = ({ size = 16, className = '' }: Icon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      className={className}
    >
      <rect fill="#000" x="6" y="2" width="1.75" height="12" rx="0.875" />
      <rect fill="#000" x="9.5" y="2" width="1.75" height="12" rx="0.875" />
    </svg>
  );
};
